import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=8c3ad2ca&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"
import style1 from "./RichTextEditor.vue?vue&type=style&index=1&id=8c3ad2ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3ad2ca",
  null
  
)

export default component.exports